import React from "react";
import { useNavigate } from "react-router-dom";
import { IndianRupee, Fingerprint, Lock, ArrowRight } from "lucide-react";

const AepsNewDashboard = () => {
  const navigate = useNavigate();

  // 1. Grouped data into distinct sections
  const serviceSections = [
    {
      sectionTitle: "Cash Withdrawals",
      sectionDesc: "Secure biometric cash withdrawal services",
      cards: [
        {
          title: "AEPS Cash Withdraw 1",
          icon: <Fingerprint className="w-6 h-6 text-blue-600" />,
          route: "/aepsform",
          accent: "bg-blue-500",
        },

        // Vimo pay pipe 2

        {
          title: "AEPS Cash Withdraw 2",
          icon: <Fingerprint className="w-6 h-6 text-emerald-600" />,
          route: "/aepsform4",
          accent: "bg-emerald-500",
        },

        // Vimp pay pipe 4

        {
          title: "AEPS Cash Withdrawal 3",
          icon: <Fingerprint className="w-6 h-6 text-cyan-600" />,
          route: "/aepsform5",
          accent: "bg-cyan-500",
        },

        // Figpay
        {
          title: "AEPS Cash Withdraw 4",
          icon: <Fingerprint className="w-6 h-6 text-rose-600" />,
          route: "/aepsform1",
          accent: "bg-rose-500",
        },
        {
          title: "AEPS Cash Withdraw 4",
          icon: <Fingerprint className="w-6 h-6 text-purple-600" />,
          route: "/aepsform2",
          accent: "bg-purple-500",
          disabled: true,
        },
        {
          title: "AEPS Cash Withdraw 5",
          icon: <Fingerprint className="w-6 h-6 text-teal-600" />,
          route: "/aepsform3",
          accent: "bg-teal-600",
          disabled: true,
        },

      ],
    },
    {
      sectionTitle: "Fund Settlements",
      sectionDesc: "Transfer funds to your registered bank account",
      cards: [
        {
          title: "Settlement 1 (IMPS)",
          icon: <IndianRupee className="w-6 h-6 text-green-600" />,
          route: "/aepssettlement1",
          accent: "bg-green-500",
        },
        {
          title: "Settlement 2 (UPI)",
          icon: <IndianRupee className="w-6 h-6 text-gray-500" />,
          route: "/aepssettlement2",
          accent: "bg-gray-400",
          // disabled: true,
        },
        {
          title: "Settlement 1 (IMPS 2)",
          icon: <IndianRupee className="w-6 h-6 text-orange-600" />,
          route: "/aepssettlement1imps2",
          accent: "bg-orange-500",
          extraText: "Only for ₹5k to ₹25k — Instant Success",
          disabled: true,
        },
        
      ],
    },
  ];

  return (
    <div className="bg-[#F5F7FB] px-4 py-10 min-h-screen font-sans">
      <div className="max-w-6xl mx-auto">
        {/* PAGE HEADER */}
        <div className="mb-10">
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
            AEPS Dashboard
          </h1>
          <p className="text-gray-500 mt-2 text-sm">
            Select a service below to proceed with your transaction.
          </p>
        </div>

        {/* SECTIONS */}
        <div className="space-y-10">
          {serviceSections.map((section, sectionIdx) => (
            <div key={sectionIdx}>
              {/* SECTION HEADER */}
              <div className="mb-6 border-b border-gray-200 pb-2">
                <h2 className="text-xl font-semibold text-gray-800">
                  {section.sectionTitle}
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                  {section.sectionDesc}
                </p>
                {section.sectionTitle === "Fund Settlements" && (
                  <div className="mt-3 flex items-start gap-2.5 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mt-0.5 h-4 w-4 shrink-0 text-red-500"
                      viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"
                    >
                      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                      <line x1="12" y1="9" x2="12" y2="13" />
                      <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                    <p className="text-sm font-medium text-red-600">
                      Settlement 1 (IMPS) transactions are allowed only for amounts between{" "}
                      <span className="font-bold">₹1,001</span> and{" "}
                      <span className="font-bold">₹1,00,000</span>.
                    </p>
                  </div>
                )}
                {section.sectionTitle === "Fund Settlements" && (
                  <div className="mt-3 flex items-start gap-2.5 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="mt-0.5 h-4 w-4 shrink-0 text-red-500"
                      viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"
                    >
                      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                      <line x1="12" y1="9" x2="12" y2="13" />
                      <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                    <p className="text-sm font-medium text-red-600">
                      Settlement 2 (UPI) transactions are allowed only for amounts between{" "}
                      <span className="font-bold">₹100</span> and{" "}
                      <span className="font-bold">₹50,000</span>.
                    </p>
                  </div>
                )}
              </div>

              {/* GRID */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {section.cards.map((card, i) => (
                  <div
                    key={i}
                    onClick={() => !card.disabled && navigate(card.route)}
                    className={`
                      relative group bg-white rounded-2xl p-5 border border-gray-100 shadow-sm
                      flex items-center gap-4 transition-all duration-300 h-full min-h-[100px]
                      ${card.disabled
                        ? "opacity-60 cursor-not-allowed bg-gray-50"
                        : "cursor-pointer hover:shadow-lg hover:-translate-y-1 hover:border-gray-200"
                      }
                    `}
                  >
                    {/* LEFT COLOR STRIP */}
                    <div
                      className={`absolute left-0 top-0 h-full w-1.5 ${card.accent} rounded-l-2xl`}
                    />

                    {/* DISABLED BADGE */}
                    {card.disabled && (
                      <div className="absolute top-3 right-3 bg-red-50 text-red-600 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full flex items-center gap-1">
                        <Lock className="w-3 h-3" />
                        Disabled
                      </div>
                    )}

                    {/* ACTIVE ARROW INDICATOR */}
                    {!card.disabled && (
                      <div className="absolute top-4 right-4 text-gray-300 opacity-0 transform -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                        <ArrowRight className="w-4 h-4" />
                      </div>
                    )}

                    {/* ICON CONTAINER */}
                    <div className="p-3 bg-gray-50 rounded-xl border border-gray-100 shrink-0">
                      {card.icon}
                    </div>

                    {/* TEXT CONTENT (Using min-w-0 for flex truncation) */}
                    <div className="flex-1 min-w-0 pr-4">
                      <h3 className="text-[16px] font-semibold text-gray-800 leading-tight truncate">
                        {card.title}
                      </h3>

                      <p className="text-sm text-gray-400 mt-1 truncate">
                        {card.disabled ? "Currently unavailable" : "Click to continue"}
                      </p>

                      {/* EXTRA TEXT (Forced to single line with truncate) */}
                      {card.extraText && !card.disabled && (
                        <p
                          className="text-[11px] font-medium text-orange-600 mt-1.5 bg-orange-50 block w-full truncate px-2 py-1 rounded-md"
                          title={card.extraText}
                        >
                          {card.extraText}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AepsNewDashboard;